export const DOWNLOAD_FILE = 'DOWNLOAD_FILE';

function requestDownloadFile(filename) {
  return {
    type: DOWNLOAD_FILE,
    downloadedFilename: filename
  };
}

export function downloadFile(
  data,
  filename,
  mimeType
) {
  return (dispatch) => {
    const blob = new Blob([data], { type: mimeType });
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      window.navigator.msSaveBlob(blob, filename);
    } else {
      const blobUrl = window.URL.createObjectURL(blob);
      const tempLink = document.createElement('a');
      tempLink.href = blobUrl;
      tempLink.setAttribute('download', filename);
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
    }
    dispatch(requestDownloadFile());
  };
}
